module.exports = __webpack_public_path__ + "img/Step1.a92aa309.png";